// WordPress dependencies
import { TabPanel } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

// Internal dependencies
import SlidersTab from './tabs/SlidersTab';
import SettingsTab from './tabs/SettingsTab';
import CarouselPreviewTab from './CarouselPreviewTab';

const TabsList = [
	{
		name: 'sliders',
		title: __( 'Sliders', 'wp-before-after-image-slider' ),
		className: 'tab-sliders',
	},
	{
		name: 'settings',
		title: __( 'Settings', 'wp-before-after-image-slider' ),
		className: 'tab-settings',
	},
];

export default ( props ) => {
	// Update parent attributes
	const updateAttributes = ( stateOptions ) => {
		const features = props.proFeatures;
		const isProFeature = props.proFeatureEnabled;

		// Create a single object with all updates
		const validUpdates = {};
		
		[].forEach.call( Object.entries( stateOptions ), ( [ key, value ] ) => {
			if ( features.includes( key ) && ! isProFeature ) {
				return;
			}
			validUpdates[ key ] = value;
		} );
		
		// Update all attributes at once
		if ( Object.keys( validUpdates ).length > 0 ) {
			props.updateAttributes( validUpdates );
		}
	};

	const renderTab = ( tab ) => {
		let ActiveTab = SlidersTab;

		if ( tab.name === 'settings' ) {
			ActiveTab = SettingsTab;
		}

		return <ActiveTab { ...props } tabInfo={ tab } updateAttributes={ updateAttributes } />;
	};

	return (
		<div className="coca-bais-tabs-wrapper">
			<TabPanel
				className="coca-bais-carousel-panel"
				orientation="horizontal"
				tabs={ TabsList }
				initialTabName={ props.attributes.active_tab }
				selectOnMove={ true }
				onSelect={ ( tabName ) => {
					updateAttributes( { active_tab: tabName } );
				} }
			>
				{ ( tab ) => renderTab( tab ) }
			</TabPanel>
			<div className="coca-bais-preview-btn-wrapper">
				<CarouselPreviewTab attributes={ props.attributes } />
			</div>
		</div>
	);
};
